import { BoldIcon, CanoeIcon, ItalicIcon, UnderlineIcon } from 'canoe';
import React from 'react';

import { ValueBox, ValueBoxGroupOptions, ValueToggle } from '@candu-ai/craft/ui';
import { StylesHierarchy } from 'craft/hooks';

interface FormatButtonProps {
  format: string;
  tooltip: string;
  icon: CanoeIcon;
  marks: string[];
  toggleMark: (newMark: string) => void;
  isDefaultActive: boolean;
}

export const FormatButton = ({
  format,
  icon,
  tooltip,
  marks,
  toggleMark,
  isDefaultActive,
}: FormatButtonProps) => {
  const isActive = marks.indexOf(format) > -1;

  return (
    <ValueToggle
      toggleGroup="text-style"
      onMouseDown={(e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        toggleMark(format);
      }}
      isActive={isActive || isDefaultActive}
      icon={icon}
      tooltip={tooltip}
    />
  );
};

interface TextStyleProps {
  marks: string[];
  toggleMark: (newMark: string) => void;
  isInGroup?: ValueBoxGroupOptions;
  stylesHierarchy: StylesHierarchy;
}

export const TextStyle = ({ marks, toggleMark, isInGroup, stylesHierarchy }: TextStyleProps) => {
  return (
    <ValueBox label="Text Style" isInGroup={isInGroup}>
      <FormatButton
        format="B"
        tooltip="Bold"
        icon={BoldIcon}
        marks={marks}
        toggleMark={toggleMark}
        isDefaultActive={false}
      />
      <FormatButton
        format="Em"
        tooltip="Italic"
        icon={ItalicIcon}
        marks={marks}
        toggleMark={toggleMark}
        isDefaultActive={stylesHierarchy?.fontStyle?.fallbackValue === 'italic'}
      />
      <FormatButton
        format="U"
        tooltip="Underline"
        icon={UnderlineIcon}
        marks={marks}
        toggleMark={toggleMark}
        isDefaultActive={stylesHierarchy?.textDecoration?.fallbackValue === 'underline'}
      />
    </ValueBox>
  );
};
